import { Store } from "@ngrx/store";
import { AppState } from "../app.state";
import { Injectable } from "@angular/core";
import { selectCsoId, selectUserInformation } from "./selectors/user-profile.selectors";
import { Observable } from "rxjs";
import { logoutAction } from "./actions/auth.actions";
import { selectFilterProfile } from "./selectors/filter-profile.selectors";
import { IFilterProfile } from "@interfaces/tankProfile";
import { IUserInformation } from "@interfaces/userInformation";
import { selectGridFilter } from "./selectors/tank-profile.selectors";
import { IServerSideGetRowsRequest } from "@ag-grid-community/core";

@Injectable()
export class TapAppStore {
  
  store: Store<AppState>;
  constructor(store: Store<AppState>) {
    this.store = store;
  }

  getCsoId$() {
    return this.store.select(selectCsoId);
  }

  getCurrentFilterProfile$(): Observable<IFilterProfile> {
    return this.store.select(selectFilterProfile);
  }

  getCurrentUserInformation$(): Observable<IUserInformation> {
    return this.store.select(selectUserInformation);
  }

  getCurrentGridFilter$(): Observable<IServerSideGetRowsRequest> {
    return this.store.select(selectGridFilter);
  }

  logout() {
    this.store.dispatch(logoutAction());
  }

}
